import React, {Component} from 'react';
import {
    List,
    TextField,
    BooleanInput,
    translate,
    Filter,
    TextInput,
    SelectInput,
    Pagination,
    downloadCSV,
    AutocompleteArrayInput, SearchInput, NumberInput
} from 'react-admin';
import {parse} from 'json2csv';
import {Link, useNavigate} from 'react-router-dom';
import {Datagrid} from 'react-admin';
import {IirsaCountriesService} from '~config/services/iirsa_countries.service';
import {statusChoices, fundingSourcesChoices, stagesChoices, sectorChoices} from '~constants/fieldGroups';

import CustomDatagrid from '../components/CustomDatagrid';
import NumberBetweenInput from '../components/NumberBetweenInput';
// import NestedSelectInput from '../components/NestedSelectInput';
import ProjectsData from '../components/ProjectsData';

import styles from './styles.module.scss';
import Breadcrumb from "~components/Breadcrumb";
import i18next from "i18next";

import CustomList from "../components/CustomList";
import {RA_LIST_CUSTOM_STYLE} from "~screens/Dashboard/screens/ProjectsIIRSA/constants";
import {useSyncStoreToLocation} from "../hooks/useSyncStoreToLocation";

class RouteFilter extends Component {
    state = {
        countries: []
    };

    constructor() {
        super({});
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => this.setState({countries: r.data}));
    }

    render() {
        return (
            <Filter {...this.props}>
                <SearchInput source={'search'} alwaysOn variant={'outlined'}/>

                <AutocompleteArrayInput
                    label={i18next.t('projects-iirsa:countries')}
                    source="iirsa_countries"
                    choices={this.state.countries}
                    variant={'outlined'}
                />

                <NumberInput label={i18next.t('projects-iirsa:projectsMin')} source={'cantidad_proyectos_min'} variant={'outlined'}/>
                <NumberInput label={i18next.t('projects-iirsa:projectsMax')} source={'cantidad_proyectos_max'} variant={'outlined'}/>

                <NumberInput label={i18next.t('projects-iirsa:totalInvestmentMin')} source={'inversion_total_min'} variant={'outlined'}/>
                <NumberInput label={i18next.t('projects-iirsa:totalInvestmentMax')} source={'inversion_total_max'} variant={'outlined'}/>
            </Filter>
        );
    }
}

// eslint-disable-next-line react/no-multi-comp
const PostPagination = props => {
    return <Pagination rowsPerPageOptions={[25, 50, 100]}  {...props} />;
};

export const financingChoices = [
    {id: 'public_project', name: 'Público'},
    {id: 'private_project', name: 'Privado'},
    {id: 'mixed_project', name: 'Mixto'}
];

function formatProject(p) {
    delete p.starredAt;
    // delete p.kmlSimplified;
    delete p.dynamicMapZoom;
    delete p.staticMapZoom;
    delete p.dynamicCenterLatitude;
    delete p.dynamicCenterLongitude;
    delete p.dynamicCenter;
    delete p.staticCenter;
    delete p.projectType;
    delete p.sources;
    delete p.editable;
    delete p.createdDate;
    delete p.updatedDate;
    delete p.totalInvestment;
    delete p.galleryItems;
    delete p.link;

    p.Sector = p.iirsaSector.name;
    delete p.iirsaSector;

    p.Subsector = p.iirsaSubsector.name;
    delete p.iirsaSubsector;

    p.Etapa = p.iirsaStage.name;
    delete p.iirsaStage;

    p.Estado = p.iirsaStatus.name;
    delete p.iirsaStatus;

    p.Alcance = p.iirsaScope.name;
    delete p.iirsaScope;

    p.Tipo_de_Obra = p.iirsaProjectType ? p.iirsaProjectType.name : '';
    delete p.iirsaProjectType;

    p.Estado_de_los_Estudios = p.iirsaStudiesState ? p.iirsaStudiesState.name : '';
    delete p.iirsaStudiesState;

    p.Financiador_de_los_Estudios = p.iirsaStudiesFunder ? p.iirsaStudiesFunder.name : '';
    delete p.iirsaStudiesFunder;

    // let elements = p.iirsaProjectFunding;
    // if (elements && elements.length > 0) {
    //     for(let i = 0; i <  elements.length; i++) {
    //         const prefix = 'FINANCIAMIENTO_' + (i + 1).toString() + '_';
    //         p[prefix + 'MONTO'] = elements[i].amount;
    //         p[prefix + 'TIPO'] = elements[i].fundingType ? elements[i].fundingType.name : "";
    //         p[prefix + 'FINANCIADOR'] = elements[i].funder ? elements[i].funder.name : "";
    //         p[prefix + 'ESTADO'] = elements[i].fundingStatus ? elements[i].fundingStatus.name : "";
    //     }
    // }
    // delete p.iirsaProjectFunding;
    delete p.iirsaSegments;
    delete p.iirsaLink;
    delete p.iirsaCountries;
}

const formatRoute = r => {
    r[i18next.t('projects-iirsa:name')] = r.name;
    r[i18next.t('projects-iirsa:description')] = r.description;
    r[i18next.t('projects-iirsa:countries')] = r.countriesFormatted;
    r[i18next.t('projects-iirsa:projects')] = r.projects;
    r[i18next.t('projects-iirsa:totalInvestmentCsv')] = r.totalInvestmentFormatted;
}

const exporter = proj => {
    const page = proj?.page || proj || [];
    page.forEach(p => {
        formatRoute(p);
    });
    const fields = [
        i18next.t('projects-iirsa:name'),
        i18next.t('projects-iirsa:description'),
        i18next.t('projects-iirsa:countries'),
        i18next.t('projects-iirsa:projects'),
        i18next.t('projects-iirsa:totalInvestmentCsv')
    ];
    const formattedCsv = parse(proj, {fields});
    downloadCSV(formattedCsv, i18next.t('projects-iirsa:routes'));
};

// eslint-disable-next-line react/no-multi-comp
function RoutesList(props) {
    const navigate = useNavigate();

    useSyncStoreToLocation({
        storeKey: 'routes.listParams',
        sort: {field: 'id', order: 'ASC'},
        perPage: 50,
    });

    return (<CustomList
        mapPath={'/routes/map'}
        title={i18next.t('projects-iirsa:countries')}
        listPath={'/routes'}
        listLabel={i18next.t('projects-iirsa:countries')}
        chartsPath={'/routes/charts'}
        chartsLabel={i18next.t('projects-iirsa:charts')}
        {...props}
    >
        <List
            {...props}
            bulkActionButtons={false}
            exporter={exporter}
            filters={<RouteFilter />}
            // pagination={<PostPagination />}
            perPage={50}
            syncWithLocation={true}
            storeKey='routes.listParams'
            disableSyncWithLocation={false}
            sx={RA_LIST_CUSTOM_STYLE}
        >
            <CustomDatagrid rowClick="show" bulkActionButtons={false} >
                <TextField source="name" label={i18next.t('projects-iirsa:name')} sortBy={'nombre'}/>
                <TextField source="countriesFormatted" label={i18next.t('projects-iirsa:countries')} sortBy={'paises_string'}/>
                <TextField source="projects" label={i18next.t('projects-iirsa:projects')} sortBy={'cantidad_proyectos'} textAlign={'center'} />
                <TextField
                    className={styles.textAlignRight}
                    source="totalInvestmentFormatted"
                    label={i18next.t('projects-iirsa:totalInvestment')}
                    sortBy={'inversion_total'}
                    align={'right'}
                />
            </CustomDatagrid>
        </List>
    </CustomList>);
}

export default RoutesList;
